var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewShopIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.625,
    height: 13,
    viewBox: "0 0 14.625 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shopping-cart",
    "data-name": "Icon awesome-shopping-cart",
    d: "M13.409,7.651l1.2-5.281a.609.609,0,0,0-.594-.744H4.042L3.81.487A.609.609,0,0,0,3.213,0H.609A.609.609,0,0,0,0,.609v.406a.609.609,0,0,0,.609.609H2.384l1.784,8.72a1.422,1.422,0,1,0,1.7.217h5.323a1.422,1.422,0,1,0,1.615-.264l.14-.616a.609.609,0,0,0-.594-.744H5.538l-.166-.812h7.443A.609.609,0,0,0,13.409,7.651Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShopIco);
export default __webpack_public_path__ + "static/media/new-shop-ico.b346220e.svg";
export { ForwardRef as ReactComponent };